// src/components/WineClub/Cancel.tsx

import React from 'react';
import { Link } from 'react-router-dom';

const Cancel: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[75vh] bg-gold text-cream font-satoshi">
      <h1 className="text-4xl font-recia mb-4">Subscription Cancelled</h1>
      <p className="mb-8">Your subscription process was cancelled. Feel free to try again.</p>
      <Link to="/" className="bg-maroon text-cream font-satoshi px-6 py-2 rounded-full">
        Return to Home
      </Link>
    </div>
  );
};

export default Cancel;